module.exports = __webpack_public_path__ + "img/rtl.675e88dd.jpg";